import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';

interface IPacientes {
  Nuevos: number;
  Prevalentes: number;
  Muertes: number;
}

interface ICostos {
  Nuevos: number;
  Prevalentes: number;
  Total: number;
}

interface IGeneroData {
  pae: number;
  prevalence: number;
  sexo: string;
  pacientes: IPacientes;
  costos: ICostos;
  costos_parciales: number;
  costo_anual_nuevos?: number;
  costo_anual_prevalente?: number;
}

interface IDetallesPorGenero {
  masculino?: IGeneroData;
  femenino?: IGeneroData;
  ambos?: IGeneroData;
}

interface ICargaEconomica {
  [enfermedad: string]: {
    Detalles_por_genero: IDetallesPorGenero;
    Total_costos: number;
    Total_pacientes: number;
  };
}

@Component({
  selector: 'app-obesity-economic-burden',
  templateUrl: './obesity-economic-burden.component.html',
  styleUrls: ['./obesity-economic-burden.component.css']
})
export class ObesityEconomicBurdenComponent implements OnInit, OnDestroy {
  @Input() codigo: string;
  cargaEconomicaData: ICargaEconomica = {};
  enfermedadesList: string[] = [];
  active: string = '';
  private intervalId: any;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.loadCargaEconomicaFromLocalStorage();

    this.intervalId = setInterval(() => {
      this.loadCargaEconomicaFromLocalStorage();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  loadCargaEconomicaFromLocalStorage(): void {
    const storedData = localStorage.getItem('valor_por_defecto');
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        if (JSON.stringify(parsedData) !== JSON.stringify(this.cargaEconomicaData)) {
          this.cargaEconomicaData = parsedData;
          this.enfermedadesList = Object.keys(this.cargaEconomicaData);

          if (!this.active && this.enfermedadesList.length > 0) {
            this.active = this.enfermedadesList[0];
          }

          this.cdRef.detectChanges();
        }
      } catch (error) {
        console.error('Error al cargar los datos del localStorage', error);
      }
    }
  }

  saveToLocalStorage(): void {
    localStorage.setItem('valor_por_defecto', JSON.stringify(this.cargaEconomicaData));
  }

  recalcularCostos(enfermedad: string, genero: string): void {
    if (
      this.cargaEconomicaData[enfermedad] &&
      this.cargaEconomicaData[enfermedad].Detalles_por_genero &&
      this.cargaEconomicaData[enfermedad].Detalles_por_genero[genero]
    ) {
      const generoData = this.cargaEconomicaData[enfermedad].Detalles_por_genero[genero];

      const nuevos = generoData.pacientes.Nuevos || 0;
      const prevalentes = generoData.pacientes.Prevalentes || 0;
      const anualNuevos = generoData.costo_anual_nuevos || 0;
      const anualPrevalentes = generoData.costo_anual_prevalente || 0;

      generoData.costos.Nuevos = nuevos * anualNuevos;
      generoData.costos.Prevalentes = prevalentes * anualPrevalentes;
      generoData.costos.Total = generoData.costos.Nuevos + generoData.costos.Prevalentes;

      this.recalcularTotalCostos(enfermedad);
      this.saveToLocalStorage();
    }
  }

  actualizarCostosDesdeCostoAnual(enfermedad: string, genero: string): void {
    this.recalcularCostos(enfermedad, genero);
  }

  private recalcularTotalCostos(enfermedad: string): void {
    let total = 0;
    const detalles = this.cargaEconomicaData[enfermedad].Detalles_por_genero;

    if (detalles.masculino && detalles.masculino.costos) {
      total += detalles.masculino.costos.Total || 0;
    }
    if (detalles.femenino && detalles.femenino.costos) {
      total += detalles.femenino.costos.Total || 0;
    }
    if (detalles.ambos && detalles.ambos.costos) {
      total += detalles.ambos.costos.Total || 0;
    }

    this.cargaEconomicaData[enfermedad].Total_costos = total;
  }

  public getCostosPorGenero(enfermedad: string, genero: string): ICostos {
    if (
      this.cargaEconomicaData[enfermedad] &&
      this.cargaEconomicaData[enfermedad].Detalles_por_genero &&
      this.cargaEconomicaData[enfermedad].Detalles_por_genero[genero]
    ) {
      return this.cargaEconomicaData[enfermedad].Detalles_por_genero[genero].costos;
    } else {
      return { Nuevos: 0, Prevalentes: 0, Total: 0 };
    }
  }

  public getTotalCostos(enfermedad: string): number {
    if (this.cargaEconomicaData[enfermedad]) {
      return this.cargaEconomicaData[enfermedad].Total_costos || 0;
    }
    return 0;
  }
}
